module.exports = __webpack_public_path__ + "img/transparent-btn.38c04a5d.svg";